import { render, staticRenderFns } from "./EntityRecommendations.vue?vue&type=template&id=76da63f1&scoped=true&"
import script from "./EntityRecommendations.vue?vue&type=script&setup=true&lang=js&"
export * from "./EntityRecommendations.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EntityRecommendations.vue?vue&type=style&index=0&id=76da63f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76da63f1",
  null
  
)

export default component.exports